import React from 'react';
import Dialog from '@dashboard/components/Dialog';
import { Form } from '@dashboard/components/Formik';
import { toast } from '@dashboard/context/ToastContext';

const MoveTicketTypeDialog = ({
  isOpen,
  onClose,
  onMove,
  ticketType,
  availableGroups,
  isLoading = false,
}) => {

  return (
    <Dialog
      title="Move ticket"
      cancelButton={null}
      confirmButton={null}
      open={isOpen}
      onCancel={onClose}
    >
      <Form
        initialValues={{
          targetGroupId: '',
        }}
        fields={[
          {
            name: 'targetGroupId',
            type: 'select',
            label: 'Move to group',
            required: true,
            autoFocus: true,
            options: [
              {
                label: 'Choose ticket group',
                value: '',
                disabled: true,
              },
              ...availableGroups.map(group => ({
                label: group.name,
                value: group._id,
              })),
            ],
          },
        ]}
        onSubmit={async values => {
          try {
            await onMove(values.targetGroupId);
            const targetGroup = availableGroups.find(group => group._id === values.targetGroupId);
            toast({
              title: `Moved "${ticketType?.name}" to "${targetGroup?.name}"`,
              type: 'success',
            });
            onClose();
            return { success: true };
          } catch (error) {
            return { error: error.message || 'Failed to move ticket type' };
          }
        }}
        submitButton={{
          label: 'Move ticket',
          disabled: isLoading,
        }}
        formSubmitAlign="end"
        cancelButton={null}
        showState={false}
      ></Form>
    </Dialog>
  );
};

export default MoveTicketTypeDialog;
